@import '../../../../style/lib/scss';
@import '../../../../style/src/typography/mixins';

:host {
	@include zds-typography('body');

	display: block;
	position: absolute;
	z-index: 2050;
}

:host([open='false']),
:host(:not([open])) {
	display: none;
	pointer-events: none;
}

.zds-popout {
	background: var(--zds-popout-background);
	border-color: var(--zds-popout-border-color);
	border-radius: var(--zds-popout-border-radius);
	border-style: solid;
	border-width: var(--zds-popout-border-width);
	box-shadow: var(--zds-popout-box-shadow);
	max-height: inherit;
	opacity: 0;
	transition: opacity var(--zds-transition-sm);

	&--visible {
		opacity: 1;
	}

	&--is-hiding {
		opacity: 0;
	}

	&--animation-grow {
		transform: scale(0);
	}

	&--animation-grow#{&}--visible {
		animation: grow-in 400ms cubic-bezier(0.13, 0.38, 0.33, 1.1) forwards;
	}

	&--animation-grow#{&}--is-hiding {
		animation: grow-out 250ms cubic-bezier(0.6, -0.1, 0.735, 0.045) forwards;
	}

	&--dynamic-width {
		width: var(--zds-popout-dynamic-width);
	}

	&__wrapper {
		max-height: inherit;
		overflow-y: auto;
		padding: var(--zds-popout-inset);
	}

	&__arrow,
	&__arrow-wrapper {
		clip-path: polygon(0 0, 83% 34%, 92% 39%, 97% 44%, 100% 50%, 97% 56%, 92% 61%, 83% 66%, 0 100%);
	}

	&__arrow {
		// Default arrow orientation is left
		background-color: var(--zds-popout-border-color);
		border-left: 1px solid var(--zds-popout-background);
		height: 12px;
		padding: 1px 1px 1px 0;
		position: absolute;
		width: 8px;
	}

	&__arrow-wrapper {
		background-color: var(--zds-popout-background);
		height: 100%;
		width: 100%;
	}
}

@keyframes grow-in {
	from {
		opacity: 0;
		transform: scale(0);
	}

	to {
		opacity: 1;
		transform: scale(1);
	}
}

@keyframes grow-out {
	from {
		opacity: 1;
		transform: scale(1);
	}

	to {
		opacity: 0;
		transform: scale(0);
	}
}
